var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0076 24.2693L49.3289 2.22671H45.8444L44.7346 0.47583H43.0844L29.3447 24.2693H62.0076Z",
    fill: "#7600AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3504 24.2695L16.4274 36.3704L8.84313 40.7462L0.75 54.7618L6.29013 64.1889L29.3448 24.2695H23.3504Z",
    fill: "#5C0095"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0845 0.47583H32.102L26.1306 10.8143L28.5801 15.1268L23.3505 24.2693H29.3448L43.0845 0.47583Z",
    fill: "#5900AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3606 65.6179L11.2121 68.6999H43.2655L45.0422 65.6179H9.3606Z",
    fill: "#460063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4577 30.2697L62.0077 24.2695H29.3448L6.29016 64.1889L7.12966 65.6178H45.0423L65.4577 30.2697Z",
    fill: "#8800B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2656 68.6999H45.3097L47.9748 73.4207H49.7142L47.0692 68.6999H74.0798L75.8997 65.6179H45.0423L43.2656 68.6999Z",
    fill: "#2F0031"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4576 30.2695L45.0422 65.6177H75.8996L80.9107 57.1393L65.4576 30.2695Z",
    fill: "#470056"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6693 37.0461L33.9706 25.3995L27.2431 37.0461H40.6693ZM36.6041 50.4551L40.3789 57.0158H75.8248L72.0499 50.4551H36.6041ZM31.7626 45.2398L21.2573 63.4328H42.2247L31.7626 45.2398ZM43.4092 49.0463H71.2392L57.3529 24.9021L43.4092 49.0463ZM34.8934 23.8038L45.4591 42.1751L56.3955 23.2375L45.8299 4.86621L34.8934 23.8038ZM19.4576 63.4328L33.8872 38.4462H26.4352L12.0056 63.4328H19.4576Z",
    fill: "url(#paint0_radial_7:112)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6176 48.7268H36.5725C36.2801 48.7268 35.9928 48.6508 35.7387 48.5061C35.4847 48.3614 35.2726 48.1531 35.1235 47.9017L33.1426 44.5696C32.9874 44.3092 32.9055 44.0116 32.9055 43.7085C32.9055 43.4054 32.9874 43.1078 33.1426 42.8474L35.1235 39.5153C35.2726 39.2639 35.4847 39.0556 35.7387 38.9109C35.9928 38.7662 36.2801 38.6902 36.5725 38.6902H40.6147C41.2098 38.6902 41.759 39.0036 42.0637 39.5153L44.0446 42.8474C44.3608 43.3793 44.3608 44.0406 44.0446 44.5696L42.0637 47.9017C41.9157 48.1535 41.7043 48.3621 41.4506 48.5069C41.1969 48.6516 40.9097 48.7275 40.6176 48.7268V48.7268Z",
    fill: "#43004D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7:112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1681 43.1986) scale(33.1976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#FFB3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#FD6EE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC3DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.db5b427e.svg";
export { ForwardRef as ReactComponent };